export enum StudentStatusId {
    Active = 1,
    AcademicLeave = 2,
    Expelled = 3,
    Exmatriculated = 4,
    ScientificDegreeCandidate = 5,
    ExchangeProgram = 7,
    DoctoralDegree = 8
}

export enum StudyTypeId {
    Paid = 1,
    Budget = 2,
    Europe = 7,
    State = 9,
    Project = 866560000,
    Cofinancing = 866560001
}

export enum StudyFinanceTypeId {
    Self = 1,
    Commercial = 2,
    VP = 3,
    Country = 4,
    ESF = 5,
    LegalEntity = 6,
    RZInstitution = 7,
    RZState = 8,
    VM = 9,
    IZM = 10
}

export interface IResident {
    StudentId: string;
    StudentUpn: string;
    CertNumber: string;
    Name: string;
    Surname: string;
    StudyProgramId: string;
    StudyProgramCode: string;
    StudyProgramName: string;
    StudentStatusId: StudentStatusId;
    StudentStatusName: string;
    StudyYear: number;
    StudyBeginDate: string;
    StudyPlannedEndDate: string;
    WorkplaceId: string;
    WorkplaceName: string;
    ClinicalBaseId: string;
    ClinicalBaseName: string;
    StudyTypeId: StudyTypeId;
    StudyTypeName: string;
    StudyFinanceTypeId: StudyFinanceTypeId;
    StudyFinanceTypeName: string;
}

export interface IResidentDetails {
    Person: IPersonData[];
    AcademicVacations: IAcademicLeave[];
    WorkplaceHistory: IWorkplaceHistory[];
    ClinicalBaseHistory: IClinicalBaseHistory[];
    StudyTypeHistory: IStudyTypeHistory[];
    StudentStatusHistory: IStudentStatusHistory[];
    StudyProgramHistory: IStudyProgramHistory[];
}

export interface IPersonData {
    UniversityName: string;
    StudentId: string;
    StudentUpn: string;
    StudentStatusId: StudentStatusId;
    StudentStatusName: string;
    StudyProgramId: string;
    StudyProgramCode: string;
    StudyProgramName: string;
    StudyProgramEcts: number;
    StudyProgramLengthInYears: number;
    StudyProgramLengthInWeeks: number;
    StudyProgramManagerName: string;
    StudyProgramManagerSurname: string;
    StudyProgramSpecialityTypeName: string;
    StudyYear: number;
    CertNumber: string;
    Name: string;
    Surname: string;
    StudyBeginDate: string;
    StudyPlannedEndDate: string;
    StudyTypeId: StudyTypeId;
    StudyTypeName: string;
    StudyFinanceTypeId: StudyFinanceTypeId;
    StudyFinanceTypeName: string;
    WorkplaceId: string;
    WorkplaceName: string;
    ClinicalBaseId: string;
    ClinicalBaseName: string;
    PersonCode: string;
    MedicalPersonId: string;
    DeclaredAddress: string;
    Phone: string;
    Email: string;
    Exmatriculated: string;
    Expelled: string;
    ContactPersonId: string;
    ContactPersonFullName: string;
    ContactPersonUpn: string;
}

export interface IAcademicLeave {
    DateFrom: string;
    DateTo: string;
    StudyYear: number;
    Resumpted: string;
}

export interface IWorkplaceHistory {
    DateFrom: string;
    DateTo: string;
    CompanyId: string;
    CompanyName: string;
}

export interface IClinicalBaseHistory {
    DateFrom: string;
    DateTo: string;
    CompanyId: string;
    CompanyName: string;
}

export interface IStudyTypeHistory {
    DateFrom: string;
    DateTo: string;
    StudyTypeName: string;
}

export interface IStudentStatusHistory {
    DateFrom: string;
    DateTo: string;
    StatusId: StudentStatusId;
    StatusName: string;
}

export interface IStudyProgramHistory {
    StudentId: string;
    StudyProgramId: string;
    StudyProgramCode: string;
    StudyProgramName: string;
    StudentStatusId: StudentStatusId;
    StudentStatusName: string;
    Date: string;
}
